var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "epf-filter" }, [
    _c("div", { staticClass: "epf-filter__container", class: _vm.background }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("epf-filter-checkboxes", {
            attrs: { "filter-config": _vm.filterAvailability },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm.filterDicke
              ? _c("epf-filter-select", {
                  staticClass: "col-12 col-md-4 col-lg-3",
                  attrs: { "filter-config": _vm.filterDicke },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filterFormat
              ? _c("epf-filter-select", {
                  staticClass: "col-12 col-md-4 col-lg-3",
                  attrs: { "filter-config": _vm.filterFormat },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filterApplication
              ? _c("epf-filter-select", {
                  staticClass: "col-12 col-md-4 col-lg-3",
                  attrs: { "filter-config": _vm.filterApplication },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filterDekor
              ? _c("epf-filter-decor", {
                  staticClass: "col-12 col-md-4 col-lg-3",
                  attrs: { "filter-config": _vm.filterDekor },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filterProdukt
              ? _c("epf-filter-product", {
                  staticClass: "col-12 col-md-4 col-lg-3",
                  attrs: { "filter-config": _vm.filterProdukt },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filterStruktur
              ? _c("epf-filter-select", {
                  staticClass: "col-12 col-md-4 col-lg-3",
                  attrs: { "filter-config": _vm.filterStruktur },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filterMatnr
              ? _c("epf-filter-select-with-input", {
                  staticClass: "col-12 col-md-4 col-lg-3",
                  attrs: { "filter-config": _vm.filterMatnr },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }